import { render } from "./HeroiconsOutlineBookmark.vue?vue&type=template&id=ef75875c"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBookmark.vue"]])

export default __exports__